<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card width="100%">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Editar Movimiento</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <div v-if="showHistory">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-on="on" v-bind="attrs" icon fab @click="MostrarHistorial()">
                                        <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                            mdi-history
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Mostrar historial</span>
                            </v-tooltip>
                        </div>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">
                                    <span style="color: black;">Observación:</span>
                                    <v-textarea :counter="$store.state.maxLengthComentarios" :rules="rulestextarea"
                                        outlined v-model="data.obs" required onpaste="return false"
                                        :maxlength="$store.state.maxLengthComentarios" name="input-7-4"></v-textarea>
                                    <span style="color: #FF5C93;font-size:11px" v-if="errorobs">No hay ninguna
                                        modificación en la observación, favor de verificar</span>
                                </v-col>
                            </v-row>
                            <v-row justify="center" class="mb-8">
                                <!--<v-col cols="12" class="text-center">-->
                                <v-btn @click="Guardar()" class="ma-2" color="primary">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn @click="Limpiar()" class="ma-2">
                                    Limpiar
                                </v-btn>
                                <v-btn color="error" @click="Regresar()" class="ma-2">
                                    Regresar
                                </v-btn>
                                <!--</v-col>-->
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
                <v-card v-if="showHistoryComments" class="mt-2">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Historial Observaciones</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon fab @click="Cerrar()">
                            <v-icon color="white" dark>
                                mdi-close-circle-outline
                            </v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                            :params="displayInputs" :order="[[0, 'desc']]" @apiDT="apiDT = $event"></DataTable>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import movimiento from '@/services/Movimientos/Movimientos.service.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";

export default {
    components: {
        DataTable
    },
    data: function () {
        return {
            valid: true,
            comentarios: '',
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length <= 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            data: {},
            showHistory: false,
            showHistoryComments: false,
            urlListado: "Movimientos/ObtenerHistorial",
            columns: [
                { name: 'exobs', data: 'exobs', title: "Observación Anterior" },
                { name: 'hebfechaedit', data: 'hebfechaedit', title: "Fecha de modificación" },
                { name: 'uslogin', data: 'uslogin', title: "Usuario" },
            ],
            formatterActions: [],
            displayInputs: {
                exid: 0
            },
            apiDT: null,
            obsOld: '',
            errorobs: false,
        }

    },
    //props: ['exid', 'obs', 'nombre'],
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    watch: {
        'data.obs'(val) {
            if (val != null) {
                this.errorobs = false
            }
        }
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        async Guardar() {
            let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
            if (this.data.obs.length > 0) {
                this.data.obs = this.data.obs.trim();
                this.data.obs = this.data.obs.replace(/\s*$/, "");
            }
            if (this.$refs.form.validate() && this.data.obs.length >= 12) {
                if (this.obsOld != this.data.obs) {
                    let date = new FormData();
                    date.append("nrreporte", datos.nrreporte);
                    date.append("svindice", datos.svindice);
                    date.append("exid", this.data.exid);
                    date.append("observacion", this.data.obs);
                    movimiento.EditarMovimiento(this, date).then(dato => {
                        if (dato[0].respuesta == 1) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito",
                                text: "La observación se guardo correctamente",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                timer: 2000,
                            }).then(() => {
                                this.$router.push({ name: `${this.data.nombre}` });
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error",
                                text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                confirmButtonText: "Ok!",
                            });
                        }
                    });
                } else {
                    this.errorobs = true;
                }
            }
        },
        Limpiar() {
            this.$refs.form.reset();
            this.data.obs = '';
            this.errorobs = true;
        },
        Regresar() {
            this.$router.push({ name: `${this.data.nombre}` });
        },
        async MostrarHistorial() {
            this.showHistoryComments = true;
            this.displayInputs = {
                exid: this.data.exid
            }
        },
        Cerrar() {
            this.showHistoryComments = false
        }
    },
    async mounted() {
        this.data = await MetodosGenerales.obtenerSessionReporte("param");
        this.changeReporteMenuOption(this.data.nombre);
        this.obsOld = this.data.obs;

        //Para saber si se mostrara el historial
        let date = new FormData();
        date.append("exid", this.data.exid);
        let response = await movimiento.ComprobarHistorial(this, date);
        this.showHistory = response.data;
    }
}
</script>